<script>
import { getSalesChannels } from '@/api/dealer'

export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },

  data: () => ({
    salesChannels: []
  }),

  created() {
    this.loadSalesChannels()
  },

  methods: {
    async loadSalesChannels() {
      try {
        this.salesChannels = await getSalesChannels()
      } catch (e) {
        window.eventBus.$emit('mia-error', {
          error: ['Vertriebskanäle konnten nicht geladen werden']
        })
      }
    },

    onChange(event) {
      const selectedOptions = Array.from(event.target.selectedOptions)

      this.$emit('change', selectedOptions.length > 0 ? selectedOptions[0].value : null)
    }
  }
}
</script>

<template>
  <div>
    <label class="text-sm block mb-1 mr-2 tracking-wider text-gray-800">Disponierungs-Typ</label>

    <select
      class="w-full form-select"
      @change="onChange"
    >
      <option
        value="with_sales_report"
        :selected="value === '' || value === null"
      >
        Disponierungs-Typ wählen
      </option>
      <option
        value="with_sales_report"
        :selected="value === 'with_sales_report'"
      >
        mit Verkaufsmeldung
      </option>
      <option
        value="without_sales_report"
        :selected="value === 'without_sales_report'"
      >
        ohne Verkaufsmeldung
      </option>
    </select>
  </div>
</template>
